// extracted by mini-css-extract-plugin
export default {"toolbar":"xrVom","inner":"vlZRt","title":"z8MJI","textWrapper":"heuSu","text":"xuGUk","dropdownIcon":"dz7TD","dropdownIconOpen":"uZilq"};